import Vue from 'vue'
import Router from 'vue-router'
import goaltracking from '@/components/attendanceemployee'
import settings from '@/views/settings/profile'
import settings_billing from '@/views/settings/billing'
import settings_gmapkey from '@/views/settings/setupGmapKey'
import setting_autoswitch_sender from '@/views/settings/autoSwitchSender'
import window24hoursReport from '@/views/crm/window24hours/report'


import settings_aikeyEdit from '@/views/settings/aiKeyEdit'
// import profile from '@/components/profile'
// import clientprofile from '@/components/clientprofile'
import error404 from '@/components/error404'
import error500 from '@/components/error500'
import employeeslist from '@/components/employeeslist'
import dashboardEntry from '@/views/dashboard/entry'
import copilot from '@/views/dashboard/copilot'
import employeedashboard from '@/views/dashboard/employeedashboard'
import employees from '@/components/employees'
import invoices from '@/components/invoices'
import tickets from '@/components/tickets'
import faq from '@/views/page/faq'
import terms from '@/views/page/terms'
import privacypolicy from '@/components/privacypolicy'
import manualbook from '@/views/page/manualbook'

import changepassword from '@/components/changepassword'
import localization from '@/views/settings/localization'
import variable from '@/views/settings/variable'
import loginPage from './modules/login'

import apps from "./modules/apps";
import register from "@/views/register";
import otpConfirm from "@/views/register/confirm";
import forgotRequest from "@/views/forgot";
import forgotCheck from "@/views/forgot/check";
// import licenseList from '@/views/license/list'
import licenseList from '@/views/license/listV2'
import licenseSummary from '@/views/license/summary'
import licenseInfo from '@/views/license/info'
import agentConnect from '@/views/agentconnect'

import farmContactList from '@/views/farmContact/list'
import farmContactNearbySearch from '@/views/farmContact/nearbySearch'


import agentList from '@/views/agent/list'
import agentRoles from '@/views/agent/roles'
import agentTasks from '@/views/agent/tasks'
import monthlyAgentsStatistic from '@/views/agent/statisticMonthly'
import ticketList from '@/views/ticket/list'
import ticketDetail from '@/views/ticket/detail'

import messageReportOutbox from '@/views/messageReport/outbox'
import messageReportBroadcastPrepare from '@/views/messageReport/outbox-broadcast-prepare'
import messageReportInbox from '@/views/messageReport/inbox'
import messageReportReplyButtons from '@/views/messageReport/reply-buttons'
import messageReportReplyButtonsDetail from '@/views/messageReport/reply-buttons-detail'
import messageReportSmartReply from '@/views/messageReport/smart-reply'
import messageReportSmartReplyDetail from '@/views/messageReport/smart-reply-detail'

import orderList from '@/views/order/list'
import orderListActiveVoucher from '@/views/order/active_voucher'

import binanceView from '@/views/binance/index'
// import contacts from '@/components/contacts'
// import contacts from '@/views/contacts/list'
import contacts from '@/views/contacts/listV2'
import ContactListV2 from '@/views/contacts/ContactListV2'
import ContactSyncV2 from '@/views/contacts/ContactSyncV2'
import importContacts from '@/views/contacts/import-contact'
import syncWhatsappContacts from '@/views/contacts/sync-contact'

import replyButtonsList from '@/views/automation/replyButtons/list'
import replyLinkList from '@/views/automation/replyLink/list'
import birthdayGreetingsList from '@/views/automation/birthdayGreetings/list'
import smartReplyList from '@/views/automation/smartReply/list'
import smartReplyAwayList from '@/views/automation/smartReplyAway/list'
import smartReplyTransferList from '@/views/automation/smartReplyTransfer/list'
import customRulesList from '@/views/automation/customRules/list'
import quickReplyList from '@/views/automation/quickReply/list'
import textReplyList from '@/views/automation/textReply/list'
import welcomeChatList from '@/views/automation/welcomeChat/list'
import workingChatList from '@/views/automation/workingChat/list'
import awayChatList from '@/views/automation/awayChat/list'
import homeChatList from '@/views/automation/homeChat/list'
import customByKeywords from '@/views/automation/customByKeywords/list'
import customRulesTextList from '@/views/automation/customRulesText/list'

import referral from '@/views/referral/index'
import referralLink from '@/views/referral/link'
import referralCommission from '@/views/referral/commission'
import referralFaq from '@/views/referral/faq'

import tagsList from '@/views/crm/tags/list'
import groupList from '@/views/crm/group/list'

//toolkit
import workingHoursList from '@/views/toolkit/workingHours/list'
import operatorList from '@/views/toolkit/operator/list'
import linkGeneratorList from '@/views/toolkit/linkGenerator/list'
import widgetList from '@/views/toolkit/widget/list'
import widgetView from '@/views/toolkit/widget/view'

import messageReportBroadcast from '@/views/messageReport/broadcast'
import messageReportBroadcastV2 from '@/views/messageReport/v2/broadcast.vue'
import messageReportBroadcastWizard from '@/views/broadcast/wizard'
import messageReportBroadcastWizardV2 from '@/views/broadcast/wizardV2'
import messageReportBroadcastWizardImport from '@/views/broadcast/wizardImport'
import messageReportBroadcastInfo from '@/views/broadcast/info'
import autoFollowUpList from '@/views/autoFollowUp/list'
import autoFollowUpTemplates from '@/views/autoFollowUp/templates'
import autoFollowUpDetail from '@/views/autoFollowUp/detail'
import autoFollowUpWizard from '@/views/autoFollowUp/wizard'

import waajoFormsList from '@/views/forms/list'
import waajoFormsEditor from '@/views/forms/editor'
import waajoFormsResponses from '@/views/forms/responses'

import chatbot from './modules/ai_chatbot'
import ai_chat from './modules/ai_chat'
Vue.use(Router)

export const constantRoutes = [
  {
    path: '/redirect',
    hidden: true,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/views/redirect/index')
    }]
  },
  {
    // Titik masuk handoff sesi impersonation dari ZEUS. Tidak memakai token
    // karena kode handoff sekali pakai ditukar di halaman ini.
    path: '/auth/handoff',
    name: 'member_auth_handoff',
    hidden: true,
    meta: {
      title: 'Menyiapkan Sesi Member',
    },
    component: () => import('@/views/auth/handoff'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: 'Registration',
    },
    hidden: false,
    // component: register,
    component: () => import("@/views/subscriptionsv2/index"),
  },
  {
    path: '/registerv2',
    name: 'registerv2',
    meta: {
      title: 'Registration',
    },
    hidden: false,
    // component: register,
    component: () => import("@/views/subscriptionsv2/index"),
  },
  {
    path: '/register/confirm',
    name: 'otpConfirm',
    meta: {
      title: 'Registration OTP',
    },
    hidden: false,
    component: otpConfirm,
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    meta: {
      title: 'Forgot Password',
    },
    hidden: false,
    component: forgotRequest,
  },
  {
    path: '/forgotpassword/check',
    name: 'forgotpasswordcheck',
    meta: {
      title: 'Forgot Password',
    },
    hidden: false,
    component: forgotCheck,
  },
  loginPage,
  {
    path: '/redesign/login',
    name: 'redesign_login',
    meta: {
      title: 'Masuk',
    },
    component: () => import('@/views/redesign/login'),
  },
  {
    path: '/redesign/subscriptions',
    name: 'redesign_subscriptions',
    meta: {
      title: 'Pilihan Paket',
    },
    component: () => import('@/views/redesign/subscriptions'),
  },
  {
    path: '/redesign/order',
    name: 'redesign_order',
    meta: {
      title: 'Checkout',
    },
    component: () => import('@/views/redesign/checkout'),
  },
  {
    path: '/redesign/order-finish',
    name: 'redesign_order_finish',
    meta: {
      title: 'Hasil Transaksi',
    },
    component: () => import('@/views/redesign/orderFinish'),
  },
  {
    path: '/redesign/order/:id',
    name: 'redesign_order_detail',
    meta: {
      title: 'Invoice',
    },
    component: () => import('@/views/redesign/orderDetail'),
  },
  {
    path: '/error404',
    name: 'error404',
    hidden: true,
    component: error404,
  },
  {
    path: '/error500',
    name: 'error500',
    hidden: true,

    component: error500,
  },
  {
    path: '/sign-agent',
    meta: {
      title: 'Sign Agent',
    },
    name: 'sign-agent',
    component: () => import("@/views/login/agent"),
  },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    meta: {
      title: 'Pilihan Paket',
    },
    component: () => import("@/views/redesign/subscriptions"),
  },
  {
    path: '/subscriptionsv2',
    name: 'subscriptionsv2',
    component: () => import("@/views/subscriptionsv2/index"),
  },
  {
    path: '/prepare-order',
    name: 'prepare-order',
    component: () => import("@/views/subscriptions/prepareOrder"),
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      title: 'Checkout',
    },
    component: () => import("@/views/redesign/checkout"),
  },
  {
    path: '/order-finish',
    name: 'order_finish',
    meta: {
      title: 'Hasil Transaksi',
    },
    component: () => import("@/views/redesign/orderFinish"),
  },
  {
    path: '/terms',
    name: 'terms',
    component: terms,
  },
  {
    path: '/manualbook',
    name: 'manualbook',
    component: manualbook,
  },
  {
    path: '/form/:formId',
    name: 'waajo_public_form',
    hidden: true,
    meta: {
      title: 'Form'
    },
    component: () => import('@/views/forms/publicForm'),
  },
  // // chat,
  // {
  //   path: "*",
  //   redirect: "/404",
  //   hidden: true
  // }
];
//   ,
//   linkActiveClass: "active",
// })

export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  // 404 page must be placed at the end !!!
  {
    hidden: false,
    meta: {
      title: 'Info Broadcast'
    },
    path: '/message_report/broadcast/info',
    name: 'message_report_broadcast_info',
    component: messageReportBroadcastInfo,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Broadcast'
    },
    path: '/message_report/broadcast/wizard',
    name: 'message_report_broadcast_wizard',
    component: messageReportBroadcastWizardV2,
  },
  // {
  //   hidden: false,
  //   meta: {
  //     title: 'Message Broadcast'
  //   },
  //   path: '/message_report/broadcast/wizard_v2',
  //   name: 'message_report_broadcast_wizard_v2',
  //   component: messageReportBroadcastWizardV2,
  // },
  {
    hidden: false,
    meta: {
      title: 'Message Broadcast'
    },
    path: '/message_report/broadcast/wizard_import',
    name: 'message_report_broadcast_wizard_import',
    component: messageReportBroadcastWizardImport,
  },
  chatbot,
  {
    hidden: false,
    path: '/toolkit/widget/view',
    name: 'toolkitWidgetView',
    meta: {
      title: 'Widget View',
      roles: ['member']
    },
    component: widgetView,
  },
  {
    hidden: false,
    path: '/toolkit/widget/list',
    name: 'toolkitWidgetList',
    meta: {
      title: 'Widget',
      roles: ['member']
    },
    component: widgetList,
  },
  {
    hidden: false,
    path: '/toolkit/link_generator/list',
    name: 'toolkitLinkGeneratorList',
    meta: {
      title: 'Link Generator',
      roles: ['member']
    },
    component: linkGeneratorList,
  },
  {
    hidden: false,
    path: '/toolkit/operator/list',
    name: 'toolkitOperatorlist',
    meta: {
      title: 'Operator',
      roles: ['member']
    },
    component: operatorList,
  },
  {
    hidden: false,
    path: '/toolkit/working-hours/list',
    name: 'toolkitWorkingHourslist',
    meta: {
      title: 'Working Hours',
      roles: ['member']
    },
    component: workingHoursList,
  },
  {
    hidden: false,
    path: '/crm/group/list',
    name: 'crmgrouplist',
    meta: {
      title: 'Kontak Grup',
      // roles: ['member']
    },
    component: groupList,
  },
  {
    hidden: false,
    path: '/crm/window24hours/report',
    name: 'window24hourslist',
    meta: {
      title: 'Jendela 24 Jam',
      // roles: ['member']
    },
    component: window24hoursReport,
  },
  {
    hidden: false,
    path: '/crm/tags/list',
    name: 'crmtagslist',
    meta: {
      title: 'Tags',
      // roles: ['member']
    },
    component: tagsList,
  },
  {
    hidden: false,
    meta: {
      title: 'Affiliate Program',
      roles: ['member']
    },
    path: '/referral',
    name: 'referral',
    component: referral,
  },
  {
    hidden: false,
    meta: {
      title: 'Share Link - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/link',
    name: 'referral_link',
    component: referralLink,
  },
  {
    hidden: false,
    meta: {
      title: 'Commission - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/commission',
    name: 'referral_commission',
    component: referralCommission,
  },
  {
    hidden: false,
    meta: {
      title: 'Faq - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/faq',
    name: 'referral_faq',
    component: referralFaq,
  },
  {
    path: '/automation/reply-link/list',
    name: 'replyLinkList',
    meta: {
      title: 'Reply Link',
      roles: ['member']
    },
    hidden: false,
    component: replyLinkList,
  },
  {
    path: '/automation/reply-buttons/list',
    name: 'replyButtonsList', meta: {
      title: 'Reply Button',
      roles: ['member']
    },
    hidden: false,
    component: replyButtonsList,
  },
  {
    hidden: false,
    meta: {
      title: 'Panen Kontak',
      // roles: ['member']
    },
    path: '/farm-contact/list',
    name: 'farmContactList',
    component: farmContactList,
  },
  {
    hidden: false,
    meta: {
      title: 'Cari Kontak',
      roles: ['member']
    },
    path: '/farm-contact/nearby-search',
    name: 'farmContactNearbySearch',
    component: farmContactNearbySearch,
  },
  {
    path: '/automation/birthday-greetings/list',
    name: 'birthdayGreetingsList',
    meta: {
      title: 'Birthday Reminder',
      // roles: ['member']
    },
    hidden: false,
    component: birthdayGreetingsList,
  },

  {
    path: '/automation/smart-reply/list',
    // name: 'smartReplyList',
    name: 'smartReplyAwayList',
    meta: {
      title: 'Smart Auto Reply',
      roles: ['member']
    },
    hidden: false,
    // component: smartReplyList,
    component: smartReplyAwayList,
  },
  {
    path: '/automation/smart-reply-transfer/list',
    name: 'smartReplyTransferList',
    meta: {
      title: 'Smart Auto Reply',
      roles: ['member']
    },
    hidden: false,
    component: smartReplyTransferList,
  },
  {
    path: '/automation/quick-reply/list',
    name: 'quickReplyList',
    meta: {
      title: 'Quick Reply',
    },
    hidden: false,
    component: quickReplyList,
  },

  {
    path: '/automation/custom-rules/list',
    name: 'customRulesList',
    meta: {
      title: 'Custom Rules',
      roles: ['member']
    },
    hidden: false,
    component: customRulesList,
  },
  {
    path: '/omni/connect-to-agent-owner',
    name: 'connect-to-agent-owner',
    hidden: true,
    component: agentConnect,
  },
  {
    path: '/faq',
    name: 'faq',
    hidden: false,
    component: faq,
  },

  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    hidden: false,
    component: privacypolicy,
  },
  {
    hidden: false,
    path: '/contacts',
    name: 'contacts',
    meta: {
      title: 'Contacts',
      // roles: ['member']
    },
    component: contacts,
  },
  {
    hidden: false,
    path: '/contacts-v2',
    name: 'contactsV2',
    meta: {
      title: 'Kontak',
      // roles: ['member']
    },
    component: ContactListV2,
  },
  {
    hidden: false,
    path: '/contacts/import-contacts',
    name: 'importContacts',
    component: importContacts,
  },
  {
    hidden: false,
    path: '/contacts/sync-contacts',
    name: 'syncContacts',
    component: syncWhatsappContacts,
  },
  {
    hidden: false,
    path: '/contacts-sync-v2',
    name: 'contactsSyncV2',
    meta: {
      title: 'Sinkronisasi Kontak',
      // roles: ['member']
    },
    component: ContactSyncV2,
  },
  {
    hidden: false,
    meta: {
      title: 'License List',
      roles: ['member']
    },
    path: '/license/list',
    name: 'license',
    component: licenseList,
  },
  {
    hidden: false,
    meta: {
      title: 'Licenses Summary',
      roles: ['member']
    },
    path: '/license/summary',
    name: 'licenses_summary',
    component: licenseSummary,
  },
  {
    hidden: true,
    meta: {
      title: 'License Info',
      roles: ['member']
    },
    path: '/license/info',
    name: 'license_info',
    component: licenseInfo,
  },
  {
    hidden: false,
    meta: {
      title: 'Ticket',
      roles: ['member', 'agent']
    },
    path: '/ticket/list',
    name: 'ticketList',
    component: ticketList,
  },
  {
    hidden: false,
    meta: {
      title: 'Detail Ticket',
      roles: ['member', 'agent']
    },
    path: '/ticket/detail/:id',
    name: 'ticketDetail',
    component: ticketDetail,
  },
  {
    hidden: false,
    meta: {
      title: 'All Agents',
      roles: ['member']
    },
    path: '/agent/list',
    name: 'agentList',
    component: agentList,
  },
  {
    hidden: false,
    meta: {
      title: 'Agent Roles',
      roles: ['member']

    },
    path: '/agent/roles',
    name: 'agentRoles',
    component: agentRoles,
  },
  {
    hidden: false,
    meta: {
      title: 'Agent Tasks',
      roles: ['member']
    },
    path: '/agent/tasks',
    name: 'agent_tasks',
    component: agentTasks,
  },
  {
    hidden: false,
    meta: {
      title: 'Monthly Agents Statistic',
      roles: ['member']
    },
    path: '/agent/monthly_agents_statistics',
    name: 'monthly_agents_statistics',
    component: monthlyAgentsStatistic,
  },
  {
    hidden: true,
    meta: {
      title: 'Chat Bot Detail',
      roles: ['member']
    },
    path: '/message_report/smart_reply_detail',
    name: 'message_report_smart_reply_detail',
    component: messageReportSmartReplyDetail,
  },
  {
    hidden: false,
    meta: {
      title: 'Chat Bot',
      roles: ['member']
    },
    path: '/message_report/smart_reply',
    name: 'message_report_smart_reply',
    component: messageReportSmartReply,
  },
  {
    hidden: true,
    meta: {
      title: 'Text Reply Detail',
      roles: ['member']
    },
    path: '/message_report/reply_buttons_detail',
    name: 'message_report_reply_buttons_detail',
    component: messageReportReplyButtonsDetail,
  },
  {
    hidden: false,
    meta: {
      title: 'Text Reply',
      roles: ['member']
    },
    path: '/message_report/reply_buttons',
    name: 'message_report_reply_buttons',
    component: messageReportReplyButtons,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Outbox',
      roles: ['member']
    },
    path: '/message_report/outbox',
    name: 'message_report_outbox',
    component: messageReportOutbox,
  },
  {
    hidden: false,
    meta: {
      title: 'Broadcast Pending',
      // roles: ['member']
    },
    path: '/message_report/broadcast_prepare',
    name: 'message_report_broadcast_prepare',
    component: messageReportBroadcastPrepare,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Inbox',
      roles: ['member']
    },
    path: '/message_report/inbox',
    name: 'message_report_inbox',
    component: messageReportInbox,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Broadcast'
    },
    path: '/message_report/broadcast',
    name: 'message_report_broadcast',
    component: messageReportBroadcastV2,
  },
  {
    hidden: false,
    meta: {
      title: 'Pesan Broadcast'
    },
    path: '/broadcast-v2',
    name: 'broadcastListV2',
    component: () => import('@/views/messageReport/v2/BroadcastListV2'),
  },
  {
    hidden: false,
    meta: {
      title: 'Buat Broadcast'
    },
    path: '/broadcast-wizard-v2',
    name: 'broadcastWizardV2',
    component: () => import('@/views/broadcast/BroadcastWizardV2'),
  },
  {
    hidden: false,
    meta: {
      title: 'Detail Broadcast'
    },
    path: '/broadcast-info-v2',
    name: 'broadcastInfoV2',
    component: () => import('@/views/messageReport/v2/BroadcastInfoV2'),
  },
  {
    hidden: false,
    meta: {
      title: 'Impor Broadcast'
    },
    path: '/broadcast-import-v2',
    name: 'broadcastImportV2',
    component: () => import('@/views/broadcast/BroadcastImportV2'),
  },
  {
    hidden: false,
    meta: {
      title: 'Auto Follow Up',
      roles: ['member']
    },
    path: '/auto-follow-up',
    name: 'auto_follow_up_list',
    component: autoFollowUpList,
  },
  {
    hidden: true,
    meta: {
      title: 'Template Auto Follow Up',
      roles: ['member']
    },
    path: '/auto-follow-up/templates',
    name: 'auto_follow_up_templates',
    component: autoFollowUpTemplates,
  },
  {
    hidden: true,
    meta: {
      title: 'Detail Auto Follow Up',
      roles: ['member']
    },
    path: '/auto-follow-up/detail',
    name: 'auto_follow_up_detail',
    component: autoFollowUpDetail,
  },
  {
    hidden: true,
    meta: {
      title: 'Buat atau Ubah Alur Follow Up',
      roles: ['member']
    },
    path: '/auto-follow-up/wizard',
    name: 'auto_follow_up_wizard',
    component: autoFollowUpWizard,
  },
  {
    hidden: false,
    meta: {
      title: 'Form Builder',
      roles: ['member']
    },
    path: '/forms',
    name: 'waajo_forms_list',
    component: waajoFormsList,
  },
  {
    hidden: true,
    meta: {
      title: 'Buat Form',
      roles: ['member']
    },
    path: '/forms/new',
    name: 'waajo_forms_create',
    component: waajoFormsEditor,
  },
  {
    hidden: true,
    meta: {
      title: 'Edit Form',
      roles: ['member']
    },
    path: '/forms/:id/edit',
    name: 'waajo_forms_editor',
    component: waajoFormsEditor,
  },
  {
    hidden: true,
    meta: {
      title: 'Hasil Pengisian',
      roles: ['member']
    },
    path: '/forms/:id/responses',
    name: 'waajo_forms_responses',
    component: waajoFormsResponses,
  },
  // {
  //   hidden: false,
  //   meta: {
  //     title: 'Message Broadcast V2'
  //   },
  //   path: '/message_report/broadcast_v2',
  //   name: 'message_report_broadcast_v2',
  //   component: messageReportBroadcastV2,
  // },
  {
    hidden: false,
    meta: {
      title: 'Order List',
      roles: ['member']
    },
    path: '/order/list',
    name: 'order_list',
    component: orderList,
  },
  {
    hidden: false,
    meta: {
      title: 'Active Voucher',
      roles: ['member']
    },
    path: '/order/active_voucher',
    name: 'active_voucher',
    component: orderListActiveVoucher,
  },
  {
    hidden: false,
    path: '/goaltracking',
    name: 'goaltracking',
    component: goaltracking,
  },
  {
    path: '/',
    name: 'index',
    component: dashboardEntry,
  },
  {
    path: '/index',
    hidden: false,
    name: 'indexs',
    component: dashboardEntry,
  },
  {
    path: '/copilot',
    hidden: false,
    name: 'copilot',
    component: copilot,
  },
  {
    hidden: false,
    path: '/employeedashboard',
    name: 'employeedashboard',
    component: employeedashboard,
  },
  {
    hidden: false,
    path: '/employees',
    name: 'employees',
    component: employees,
  },
  {
    hidden: false,
    path: '/tickets',
    name: 'tickets',
    component: tickets,
  },
  {
    hidden: false,
    meta: {
      title: 'Settings',
      roles: ['member']
    },
    path: '/settings',
    name: 'settings',
    component: settings,
  },
  {
    hidden: false,
    meta: {
      title: 'Bank',
      roles: ['member']
    },
    path: '/settings/billing',
    name: 'settings_billing',
    component: settings_billing,
  },
  {
    hidden: false,
    meta: {
      title: 'Google Map Key',
      roles: ['member']
    },
    path: '/gmapkey',
    name: 'settings_gmapkey',
    component: settings_gmapkey,
  },

  {
    hidden: false,
    meta: {
      title: 'AI API Key Edit',
      roles: ['member']
    },
    path: '/aikey-edit',
    name: 'settings_aikey_edit',
    component: settings_aikeyEdit,
  },
  // ...ai_chat,
  {
    hidden: false,
    meta: {
      title: 'Message Settings',
      roles: ['member']
    },
    path: '/autoswitch-sender',
    name: 'settings_autoswitch_sender',
    component: setting_autoswitch_sender,
  },
  {
    hidden: false,
    meta: {
      title: 'Change Password',
      roles: ['member']
    },
    path: '/changepassword',
    name: 'changepassword',
    component: changepassword,
  },
  {
    meta: {
      title: 'Localization',
      roles: ['member']
    },
    hidden: false,
    path: '/localization',
    name: 'localization',
    component: localization,
  },
  {
    meta: {
      title: 'Variable',
      roles: ['member']
    },
    hidden: false,
    path: '/variable',
    name: 'variable',
    component: variable,
  },
  {
    meta: {
      title: 'Invoices',
      roles: ['member']
    },
    hidden: false,
    path: '/invoices',
    name: 'invoices',
    component: invoices,
  },
  // {
  //   meta: {
  //     title: 'Profile',
  //     roles: ['member']
  //   },
  //   hidden: false,
  //   path: '/profile',
  //   name: 'profile',
  //   component: profile,
  // },
  // {
  //   hidden: false,
  //   path: '/clientprofile',
  //   name: 'clientprofile',
  //   component: clientprofile,
  // },
  {
    hidden: false,
    path: '/employeeslist',
    name: 'employeeslist',
    component: employeeslist,
  },
  {
    hidden: false,
    path: '/binance',
    name: 'binance',
    component: binanceView,
  },
  {
    hidden: false,
    path: '/binance/order',
    name: 'binance-order',
    component: () => import('@/views/binance/order')
  },
  {
    hidden: false,
    path: '/binance/buysell',
    name: 'binance-buysell',
    component: () => import('@/views/binance/buysell')
  },
  apps,
  // { path: "*", component: () => error404, }

  {
    path: "*",
    redirect: "/error404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes,
    linkActiveClass: "active",
  });


const router = createRouter();

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GANALYTICS,
  },
}, router);

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// export default router;
export default router


// WEBPACK FOOTER //
// ./src/router/index.js